// extracted by mini-css-extract-plugin
export var siteNav = "post-module--site-nav--45Bjz";
export var siteTitle = "post-module--site-title--wwyej";
export var siteAvatar = "post-module--site-avatar--WELJ+";
export var siteAbout = "post-module--site-about--4YQbC";
export var cover = "post-module--cover--5ZLCQ";
export var article = "post-module--article--2rSZh";
export var articleHeader = "post-module--article-header--4sVcM";
export var articleTitle = "post-module--article-title--jNGmw";
export var date = "post-module--date--q9fcM";
export var readingTime = "post-module--readingTime--W2ql1";
export var tags = "post-module--tags--79VdM";
export var tag = "post-module--tag--siMuy";
export var content = "post-module--content--kk-FG";
export var previousNext = "post-module--previous-next--6SZ4g";
export var nextPost = "post-module--next-post--np1N6";
export var comments = "post-module--comments--JhU+v";
export var share = "post-module--share--ofZAG";
export var shareLinks = "post-module--share-links--VZTDM";
export var footerLink = "post-module--footer-link--Nu+xl";